import styled from '@emotion/styled';

const Background = styled.div`
  margin: 0;
  padding: 0;
  z-index: 100;
  overflow-x: hidden !important;
  background-color: var(--bg-0);
  overflow-x: hidden;
  display: grid;
  grid-template:
    'Notification'
    'Header' auto
    'Main' 1fr
    'Footer' auto / 100%;
  height: 100vh;
  @media (max-width: 800px) {
    margin-bottom: 50px;
  }
  .root {
    grid-area: Main;
    /* overflow: auto; */
    display: flex;
    @media (max-width: 800px) {
      flex-direction: column;
    }
  }
  & .radius-0 {
    border-radius: 0px;
  }

  & .disclaimer {
    justify-content: center;
    border-radius: 0px;
    padding: 8px;
    margin: 0;
    width: 100%;
    font-size: 12px;
    text-align: left;
    /* color: #c3c2d4; */
    @media (max-width: 600px) {
      font-size: 10px;
    }
  }

  /*
     The announcement bar published from the admin panel. The grid's first row is named
     'Notification' and was unused until now.

     Colours live here rather than in Tailwind classes on the component. This project's
     tailwind.config.js *replaces* theme.borderColor and theme.fontSize instead of
     extending them, so border-blue-500 does not exist at all, and it uses opacity steps
     (/12, /14, /45) that are not in the default opacity scale, so those background
     utilities are never generated either. The element carried the classes and none of
     them resolved: transparent background, Bootstrap's #212529 text on a dark bar.
     Layout utilities (flex, gap, padding) do work and are left on the component.
  */
  .announcement-slot {
    grid-area: Notification;
    /* The Tailwind py-1.5 alone left the strip 16px tall, which is legible but cramped
       above a dense trading layout. */
    min-height: 28px;
    padding: 6px 12px;
    border-bottom: 1px solid var(--ann-line);
    background: var(--ann-bg);
    color: var(--ann-body);
    font-size: 12px;
    line-height: 1.35;

    /* Dark is the default; the light variant is applied by the component when the
       app's own theme toggle is off. */
    --ann-body: rgba(255, 255, 255, 0.82);
    --ann-close: rgba(255, 255, 255, 0.55);
  }

  .announcement-slot.is-light {
    --ann-body: #374151;
    --ann-close: #6b7280;
  }

  .announcement-slot.ann-info {
    --ann-bg: rgba(59, 130, 246, 0.14);
    --ann-line: rgba(59, 130, 246, 0.42);
    --ann-accent: #93c5fd;
  }
  .announcement-slot.ann-success {
    --ann-bg: rgba(32, 178, 108, 0.14);
    --ann-line: rgba(32, 178, 108, 0.42);
    --ann-accent: #4ade80;
  }
  .announcement-slot.ann-warning {
    --ann-bg: rgba(245, 158, 11, 0.16);
    --ann-line: rgba(245, 158, 11, 0.48);
    --ann-accent: #fcd34d;
  }
  .announcement-slot.ann-critical {
    --ann-bg: rgba(239, 69, 74, 0.16);
    --ann-line: rgba(239, 69, 74, 0.52);
    --ann-accent: #fca5a5;
  }

  /* The dark palette's tints sit at 3:1 or worse on white. */
  .announcement-slot.is-light.ann-info {
    --ann-bg: #eff6ff;
    --ann-line: #bfdbfe;
    --ann-accent: #1d4ed8;
  }
  .announcement-slot.is-light.ann-success {
    --ann-bg: #ecfdf5;
    --ann-line: #a7f3d0;
    --ann-accent: #067a56;
  }
  .announcement-slot.is-light.ann-warning {
    --ann-bg: #fffbeb;
    --ann-line: #fde68a;
    --ann-accent: #92400e;
  }
  .announcement-slot.is-light.ann-critical {
    --ann-bg: #fef2f2;
    --ann-line: #fecaca;
    --ann-accent: #b91c1c;
  }

  .announcement-slot__title {
    flex: 0 0 auto;
    font-weight: 600;
    color: var(--ann-accent);
  }

  /*
     Not flex: 1. With the body growing, the call to action was pushed to the far right
     edge of a 1700px bar, stranded from the sentence it belongs to. The group stays
     together on the left and the close button takes the right via margin-left: auto.
  */
  .announcement-slot__body {
    flex: 0 1 auto;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .announcement-slot__cta {
    flex: 0 0 auto;
    color: var(--ann-accent);
    font-weight: 600;
    text-decoration: underline;
    text-underline-offset: 2px;
  }

  .announcement-slot__cta:hover {
    color: var(--ann-accent);
    opacity: 0.82;
  }

  .announcement-slot__close {
    flex: 0 0 auto;
    margin-left: auto;
    padding: 0 4px;
    border: 0;
    background: transparent;
    color: var(--ann-close);
    font-size: 15px;
    line-height: 1;
    cursor: pointer;
  }

  .announcement-slot__close:hover {
    color: var(--ann-accent);
  }

  header {
    grid-area: Header;
  }
  footer {
    grid-area: Footer;
  }
`;
export default Background;
